(function () {
var root = document.getElementById('noteflow-landing');
if (!root) return;
var ACCENT = '#4B6D13';
var flips = root.querySelectorAll('[data-nf-flip]');
flips.forEach(function (btn) {
var inner = btn.querySelector('.nf-inner');
btn.addEventListener('click', function () {
var back = !inner.classList.contains('is-back');
inner.classList.remove('is-front', 'is-peek', 'is-back');
inner.classList.add(back ? 'is-back' : 'is-front');
btn.setAttribute('aria-pressed', back ? 'true' : 'false');
});
});
if (flips[0]) {
var first = flips[0].querySelector('.nf-inner');
setTimeout(function () { if (first.classList.contains('is-front')) { first.classList.replace('is-front', 'is-peek'); } }, 1200);
setTimeout(function () { if (first.classList.contains('is-peek')) { first.classList.replace('is-peek', 'is-front'); } }, 2300);
}
var pens = root.querySelectorAll('[data-nf-pen]');
function setPen(idx) {
pens.forEach(function (b, i) {
var on = i === idx;
b.setAttribute('aria-pressed', on ? 'true' : 'false');
var lead = b.querySelector('.nf-lead'); lead.style.flexBasis = (on ? 64 : 24) + 'px'; lead.style.background = on ? ACCENT : '#D9D2C4';
var ico = b.querySelector('.nf-ico'); ico.style.background = on ? ACCENT : '#C7D3B3';
var svg = ico.querySelector('svg'); svg.setAttribute('stroke', on ? '#FCFBF8' : '#211E1C');
var det = b.querySelector('[data-nf-pen-detail]');
var label = det.previousElementSibling; if (label) label.style.fontWeight = on ? 600 : 400;
det.style.display = on ? 'block' : 'none';
});
}
pens.forEach(function (b, i) {
b.addEventListener('click', function () { setPen(i); });
b.addEventListener('mouseenter', function () { setPen(i); });
});
var selectedVariant = null;
var bundles = root.querySelectorAll('[data-nf-bundle]');
function setBundle(btn) {
bundles.forEach(function (b) {
var on = b === btn;
b.setAttribute('aria-checked', on ? 'true' : 'false');
b.style.borderColor = on ? '#C7D3B3' : 'rgba(252,251,248,0.2)';
b.style.background = on ? 'rgba(199,211,179,0.12)' : 'transparent';
b.querySelector('[data-nf-ring]').style.borderColor = on ? '#C7D3B3' : 'rgba(252,251,248,0.5)';
b.querySelector('[data-nf-dot]').style.background = on ? '#C7D3B3' : 'transparent';
});
selectedVariant = btn.getAttribute('data-nf-bundle');
var price = btn.getAttribute('data-nf-bundle-price');
root.querySelectorAll('[data-nf-price]').forEach(function (el) { el.textContent = price; });
}
bundles.forEach(function (b) {
if (b.getAttribute('aria-checked') === 'true') selectedVariant = b.getAttribute('data-nf-bundle');
b.addEventListener('click', function () { setBundle(b); });
});
var addons = {};
root.querySelectorAll('[data-nf-addon]').forEach(function (b) {
b.addEventListener('click', function () {
var id = b.getAttribute('data-nf-addon');
var on = !addons[id]; addons[id] = on;
b.setAttribute('aria-pressed', on ? 'true' : 'false');
b.textContent = on ? 'Added ✓' : 'Add';
b.style.background = on ? ACCENT : 'transparent';
b.style.color = on ? '#FCFBF8' : '#211E1C';
b.style.borderColor = on ? ACCENT : '#211E1C';
});
});
root.querySelectorAll('[data-nf-atc]').forEach(function (a) {
a.addEventListener('click', function (e) {
e.preventDefault();
if (!selectedVariant) return;
var items = [{ id: Number(selectedVariant), quantity: 1 }];
Object.keys(addons).forEach(function (id) { if (addons[id]) items.push({ id: Number(id), quantity: 1 }); });
var label = a.innerHTML; a.textContent = 'Adding…'; a.style.pointerEvents = 'none';
var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
.then(function (r) { if (!r.ok) throw r; window.location.href = base + 'cart'; })
.catch(function () { a.innerHTML = label; a.style.pointerEvents = ''; alert('Sorry, something went wrong adding this to your cart. Please try again.'); });
});
});
var sd = new Date(Date.now() + 86400000);
if (sd.getDay() === 6) sd.setDate(sd.getDate() + 2);
if (sd.getDay() === 0) sd.setDate(sd.getDate() + 1);
var shipText = sd.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' });
root.querySelectorAll('[data-nf-ship]').forEach(function (el) { el.textContent = shipText; });
var sticky = root.querySelector('.nf-sticky');
function onScroll() { if (sticky) sticky.classList.toggle('is-on', (window.scrollY || 0) > 640); }
window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
})();
